"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePaymentMethod = exports.addPaymentMethod = exports.getPaymentMethodById = exports.getPaymentMethods = void 0;
const _ = require("lodash");
const getPaymentMethods = async (supabase) => {
    const { data: airports, error } = await supabase
        .from("payment_methods")
        .select(`*`);
    if (!error)
        return airports;
    return error;
};
exports.getPaymentMethods = getPaymentMethods;
const getPaymentMethodById = async (supabase, id) => {
    const { data: airport, error } = await supabase
        .from("payment_methods")
        .select(`*`)
        .eq("id", id)
        .single();
    if (!error)
        return airport;
    return error;
};
exports.getPaymentMethodById = getPaymentMethodById;
const addPaymentMethod = async (supabase, obj) => {
    const { data, error } = await supabase
        .from("payment_methods")
        .insert([obj])
        .select();
    if (!error)
        return data;
    return error;
};
exports.addPaymentMethod = addPaymentMethod;
const updatePaymentMethod = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data, error } = await supabase
        .from("payment_methods")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updatePaymentMethod = updatePaymentMethod;
